import React from 'react'
import { styled } from "../../../stitches.config";
import Logo from "../../atoms/Logo";
import { h1, h2, h3, h4, p } from '../../commonStyles/Fonts';

type QuoteCardProps = {
    text: string,
    video: string,
}

const QuoteCard = ({ text, video }: QuoteCardProps) => {
    return (
        <Card>
            <QuoteVideo>
                <iframe src={video} frameBorder='0' allow='autoplay; encrypted-media' />
            </QuoteVideo>
            <h2 className={h2()}>{text}</h2>
        </Card>
    )
}

export default QuoteCard;

const Card = styled('div', {
    display: 'flex !important',
    flexDirection: 'column',
    gap: '24px',
    width: '90% !important',
    height: '100%',
    'h2': {
        maxHeight: '450px',
        height: '50%',
        width: '100%',
    },
    '@bp4': {
        display: 'flex !important',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '40px',
        width: '90% !important',
        height: '100%',
        'h2': {
            height: '50%',
            width: '50%',
        },
    },
    '@bp6': {
        h2: {
            fontSize: '28px',
        }
    }
})

const QuoteVideo = styled('div', {
    aspectRatio: 1.72,
    width: '100%',
    height: '50%',
    'iframe': {
        width: '100%',
        height: '100%',
    },
    '@bp4': {
        width: '50%',
        maxWidth: '500px',
        height: '50%',
        'iframe': {
            width: '100%',
            height: '100%',
        }
    }
})